export default __webpack_public_path__ + "static/media/back.7c1369fa.jpg";